/* eslint-disable jsx-a11y/control-has-associated-label */

import {
  Button, Form, Image, Input, Select, Space,
} from 'antd';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { BuilderTypes, BuilderTypes_Array } from '../../enums';
import { MBuilder } from '../../modeles';
import { GuildId, Inspector } from '../../assets/images/help';

import './builder-add.scss';
import { useBuilders } from '../../contexts';
import { midjourneyService } from '../../services';

interface ChannelType {
  id: number;
  name: string;
}

interface GuildType {
  id: number;
  name: string;
}

export function BuilderAdd(props: {
  onAdd?: () => void,
}) {
  const uBuilders = useBuilders();
  const uHistory = useHistory();
  const [form] = Form.useForm();
  const [step, _setStep] = useState(0);
  const [loading, _setLoading] = useState(false);
  const [guilds, _setGuilds] = useState<ChannelType[] | null>(null);
  const [channels, _setChannels] = useState<ChannelType[] | null>(null);
  const [builder, _setBuilder] = useState(new MBuilder());

  const onFinish = (data: any) => {
    const post = { ...builder, name: data.name, config: data.config };
    _setLoading(true);
    uBuilders.addBuilder(post).then((result: MBuilder | null) => {
      _setLoading(false);
      if (result) {
        _setStep(0);
        form.resetFields();
        _setGuilds(null);
        _setChannels(null);
        _setBuilder(new MBuilder());
        if (props.onAdd) {
          props.onAdd();
        }
        uHistory.push(`/builder/${result.id}`);
      }
    });
  };

  return (
    <div id="builder-add">
      {step === 0 && (
      <div className="row">
        {BuilderTypes_Array.map((e) => {
          return (
            <div className="col-4" key={e}>
              <Button
                className="builder"
                onClick={() => {
                  _setStep(1);
                  _setBuilder({ ...builder, type: e });
                }}
              >
                {e}
              </Button>
            </div>
          );
        })}
      </div>
      )}
      {step === 1 && (
      <div>
        <div>
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item
              rules={[{
                required: true,
                message: 'Name is required',
              },
              ]}
              label="Name"
              name="name"
            >
              <Input placeholder="" />
            </Form.Item>
            {builder.type === BuilderTypes.MIDJOURNEY && (
            <>
              <b><u>Midjourney:</u></b>
              <Form.Item
                rules={[{
                  required: true,
                  message: 'User token is required',
                },
                ]}
                label="User Token"
                name={['config', 'userToken']}
                tooltip={(<Image width={400} src={Inspector} />
            )}
              >
                <Space.Compact style={{ width: '100%' }}>
                  <Input placeholder="MTA5MTI2NTc0Mzg...." disabled={guilds != null || channels != null} />
                  <Button
                    type="primary"
                    style={{ width: '30%' }}
                    onClick={() => {
                      const config = form.getFieldsValue().config as {
                        userToken: string,
                      };
                      midjourneyService.guilds(config.userToken).then((glds: GuildType[] | null) => {
                        if (glds !== null && glds.length) {
                          _setGuilds(glds);
                        }
                      });
                    }}
                  >Check token
                  </Button>
                </Space.Compact>
              </Form.Item>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: 'Guild Id is required',
                  },
                ]}
                label="Guild Id"
                name={['config', 'guildId']}
              >
                <Select
                  placeholder="Guild"
                  disabled={guilds == null}
                  onChange={() => {
                    const config = form.getFieldsValue().config as {
                      userToken: string,
                      guildId: string,
                    };
                    midjourneyService.channels(config.userToken, config.guildId).then((chs: ChannelType[] | null) => {
                      if (chs !== null && chs.length) {
                        _setChannels(chs);
                      }
                    });
                  }}
                >
                  {guilds && guilds.map((g) => (
                    <Select.Option key={g.id} value={`${g.id}`}>{g.name}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Space.Compact style={{ width: '100%' }}>
                <Form.Item
                  style={{ width: '100%' }}
                  rules={[
                    {
                      required: true,
                      message: 'Channel Id is required',
                    },
                  ]}
                  label="Channel Id"
                  name={['config', 'channelId']}
                >
                  <Select placeholder="Channel" disabled={channels == null}>
                    {channels && channels.map((c) => (
                      <Select.Option key={c.id} value={`${c.id}`}>{c.name}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Space.Compact>
            </>
            )}
            <Button type="primary" htmlType="submit" loading={loading}>Create</Button>
          </Form>
        </div>
      </div>
      )}
    </div>
  );
}
